import React from "react";
import { ErrorMessage, FastField } from "formik";
import { RadioButtonField } from "./RadioButton";
import {
  RadioButtonGroup,
  FormField,
  ErrorMessage as BronsonErrorMessage,
  InfoIcon,
} from "@vwfs-bronson/bronson-react";

function renderRadioGroup({ fieldName, legend, tooltip, options }) {
  return (
    <FormField
      labelElement="div"
      type="checkbox"
      labelText={legend}
      infoIcon={tooltip && <InfoIcon icon="semantic-info">{tooltip}</InfoIcon>}
      noFloatingLabel
      staticLabel
      errorMessage={
        <ErrorMessage
          name={fieldName}
          render={(error) => (
            <BronsonErrorMessage id={fieldName}>{error}</BronsonErrorMessage>
          )}
        />
      }
    >
      <RadioButtonGroup>
        {options.map(({ value: label, key: value }, i) => (
          <FastField
            key={i}
            name={fieldName}
            type={"radio"}
            value={value}
            label={label}
            component={RadioButtonField}
          />
        ))}
      </RadioButtonGroup>
    </FormField>
  );
}

export default renderRadioGroup;
